<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Document</title>
  </head>
  <body>
    <footer>
      <div class="container-fluid blue-purple-gredient">
        <div class="container" id="container-infos">
          <div class="row">
            <div class="col-md-6 col-xs-8 infos-sinepsy">
              <h1 class="title-footer-flash">Contact</h1>
              <p id="intro-footer">
                Vous pouvez me contacter via les coordonnées ci-dessous du lundi
                au vendredi de
                <b>10h</b> à <b>12h30</b> et de <b>14h</b> à <b>18h</b>. Merci
              </p>

              <h6><i class="fa fa-phone"></i> Téléphone</h6>

              <a href="tel:+33650564742" class="">
                <p>06 50 56 47 42</p>
              </a>

              <h6><i class="fa fa-envelope"></i> Email</h6>

              <a href="mailto:contact.sinepsy@gmail.com" class="">
                <p>contact.sinepsy@gmail.com</p>
              </a>

              <h6><i class="fa fa-map-marker"></i> Adresse</h6>

              <a
                target="_blank"
                href="https://goo.gl/maps/QvjZs3pguCpLYzjTA"
                class=""
              >
                <p>
                  10 rue de Troènes <br />
                  44600 SAINT-NAZAIRE <br />
                  FRANCE
                </p>
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/licsjsain/?originalSubdomain=fr"
                class=""
              >
                <svg
                  style="margin: 20px; float: right"
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-linkedin"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"
                  />
                </svg>
              </a>
            </div>
            <div class="col-md-6 col-xs-4">
              <div class="iframe-position">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2706.357968919706!2d-2.2675855845036!3d47.28780377916486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805663f3d4e308b%3A0x29eeea7fa2043c2!2s12%20All.%20Andr%C3%A9%20Michaux%2C%2044600%20Saint-Nazaire!5e0!3m2!1sfr!2sfr!4v1652166434928!5m2!1sfr!2sfr"
                  width="450"
                  height="450"
                  style="border: 0"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
          <p>
            <a
              class="text-white"
              style="cursor: pointer"
              href="/mentions-legales"
              >Mentions légales</a
            >
          </p>
        </div>
      </div>
    </footer>
  </body>
</html>
